import * as Yup from 'yup';

const INVALID_EMAIL_MESSAGE = 'Please enter a valid email address.';

const emailValidationFormValidationScheme = Yup.object().shape({
	email: Yup.string().email(INVALID_EMAIL_MESSAGE).required(INVALID_EMAIL_MESSAGE),
});

export default emailValidationFormValidationScheme;
